var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.417 6.75a.75.75 0 0 1 1.5 0v10.5a.75.75 0 0 1-1.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.917 12.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 0 1.5z"
  }))));
};
export default SvgPlus;